export type HttpRequestOptions = {
  signal?: AbortSignal;
  headers?: Record<string, string>;
  query?: Record<string, unknown>;
};

type HttpMethod = "get" | "post" | "put" | "patch" | "delete";

type HttpRequestConfig = Omit<HttpRequestOptions, "query"> & {
  method: HttpMethod;
  url: string;
  data?: unknown;
  params?: Record<string, unknown>;
};

type HttpTransport = {
  request: <T>(config: HttpRequestConfig) => Promise<{ data: T }>;
};

export const createHttpRequest =
  (instance: HttpTransport, normalizeError: (error: unknown) => Error) =>
  async <T>(
    method: HttpMethod,
    url: string,
    body?: unknown,
    opts?: HttpRequestOptions,
    extraConfig?: Record<string, unknown>,
  ): Promise<T> => {
    try {
      const response = await instance.request<T>({
        ...extraConfig,
        method,
        url,
        data: body,
        params: opts?.query,
        signal: opts?.signal,
        headers: opts?.headers,
      });
      return response.data;
    } catch (error) {
      throw normalizeError(error);
    }
  };

export const createHttpError = (
  message: string,
  status: number | undefined,
  data: unknown,
) => Object.assign(new Error(message), { status, data });
